// ============================================================================
// CabinetFilesTab.tsx — вкладка «Файлы» кабинета.
//
// Не второй файловый менеджер: используется ТОТ ЖЕ экран, что у приложения
// «Файлы» (ExplorerApp), на существующих RPC FileService (список/загрузка/
// скачивание/удаление/миниатюры/разбор содержимого). Новых proto, серверных
// обработчиков и прав нет — доступ и права проверяет сервер (объект «Файлы»).
//
// Изоляция и жизненный цикл — штатные: AppHost создаёт AppSDK по манифесту
// Explorer'а (files/notify/events/nav/data:read), ловит падение вкладки и
// снимает подписки при уходе с неё. UI не дублируется.
// ============================================================================

import { AppHost } from '@/components/apps/AppHost';
import { ExplorerApp, EXPLORER_APP_MANIFEST } from '@/components/apps/explorerRenderer';

export function CabinetFilesTab() {
  return (
    <AppHost manifest={EXPLORER_APP_MANIFEST}>
      {(sdk) => <ExplorerApp sdk={sdk} />}
    </AppHost>
  );
}
